import { FlatHtmlElement } from '@planone/shared/util-interfaces';

export class HtmlElementHelper {
  public static flattenObject(htmlElement: any): FlatHtmlElement | null {
    if (!htmlElement) {
      return null;
    }

    return {
      url: htmlElement?.getAttribute('href') ?? 'UNKNOWN',
      content: htmlElement?.getAttribute('analyticsLinkText')
        ? htmlElement?.getAttribute('analyticsLinkText')
        : htmlElement?.innerHTML ?? '',
      classes: <string[]>Array.from(htmlElement?.classList ?? []),
      id: htmlElement?.getAttribute('id'),
      target: htmlElement?.getAttribute('target'),
    };
  }
}
